var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id}},[_c('svg',[_c('g',{staticClass:"angle"}),_c('g',{staticClass:"text-angle"}),_c('text',{staticClass:"center-text"}),_c('text',{staticClass:"center-text-desc"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }